import { useCallback, useRef } from 'react';

/**
 * Returns onMouseDown / onMouseUp handlers for a backdrop overlay.
 * The close callback fires only when BOTH mousedown AND mouseup happen
 * on the backdrop itself (e.target === e.currentTarget), preventing
 * accidental closes when the user drags from inside a modal to outside.
 */
export function useBackdropClose(onClose: () => void) {
  const downOnBackdropRef = useRef(false);

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    downOnBackdropRef.current = e.target === e.currentTarget;
  }, []);

  const onMouseUp = useCallback((e: React.MouseEvent) => {
    if (downOnBackdropRef.current && e.target === e.currentTarget) {
      onClose();
    }
    downOnBackdropRef.current = false;
  }, [onClose]);

  return { onMouseDown, onMouseUp };
}
